<div class="modal-content dark_bg" style="border: 1px solid #ccc">
  <spinner [id]="'approveinfo'" [show]='activeSpinner'></spinner>
  <div class="modal-header">

    <button type="button" class="close pointer text-black" (click)="activeModal.dismiss('cancel click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div id="accordion">
          <div class="card">
            <div id="approvalhistory">
              <div class="card-body">
                <div class="row mt-10">
                  <div class="col-md-6">
                    <span>Assessment Year<span class="text-star">*</span></span>
                  </div>
                  <div class="col-md-6">
                    <select [(ngModel)]="setwindowparams['assessmentyear']" class="form-control custom-selectbox">
                      <option value="">Select assessment year</option>
                      <option *ngFor="let year of yearDropDownList" value="{{year}}">
                        {{getYearAndMonth(year,0)}}</option>
                    </select>
                    <span style="color:red" [hidden]="validation[1]">Please select assessment year</span>
                  </div>
                </div>
                <div>
                  <!-- <div class="row mt-10" >
                            <div class="col-md-6">
                                <span>State<span class="text-star">*</span></span>
                            </div>
                            <div class="col-md-6">
                              <ng-multiselect-dropdown [placeholder]="" [data]="stateDropDownList" class="text-white" [(ngModel)]="setwindowparams['statearray']" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)"
                              (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)" (onDeSelectAll)="onItemDeSelectAll($event)">
                              </ng-multiselect-dropdown>
                              <span style="color:red" [hidden]="validation[3]">Please select state</span>
                            </div>
                        </div> -->

                  <div class="row mt-10">
                    <div class="col-md-6">
                      <span>Month<span class="text-star">*</span></span>
                    </div>
                    <div class="col-md-6">
                      <select [(ngModel)]="setwindowparams['month']" (change)="selectOption($event.target.value)"
                        class="form-control custom-selectbox">
                        <option value="">Select Month</option>
                        <option *ngFor="let month of monthlist" [value]="month.key">
                          {{month['value']}}</option>
                      </select>
                      <!-- <span style="color:red" [hidden]="validation[4]">Please select Month</span> -->
                    </div>
                  </div>
                  <div class="row mt-10">
                    <div class="col-md-6">
                      <span>Start Date<span class="text-star">*</span></span>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group input-group-sm">
                        <input [(ngModel)]="selectedDate" readonly (click)="sd.toggle()" id="date1"
                          aria-label="Recipient's username" aria-describedby="basic-addon2"
                          class="form-control form-control-dark" (ngModelChange)="changeStartDate($event)"
                          [(minDate)]="startDateminDate" [(maxDate)]="startDatemaxDate" name="date1"
                          placeholder="Select Date" ngbDatepicker #sd="ngbDatepicker">
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary" (click)="sd.toggle()" type="button"><i
                              class="fas fa-calendar"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-10">
                    <div class="col-md-6">
                      <span>End Date<span class="text-star">*</span></span>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group input-group-sm">
                        <input [(ngModel)]="selectedEndDate" readonly (click)="ed.toggle()" id="date2"
                          (ngModelChange)="changeEndDate($event)" aria-label="Recipient's username"
                          aria-describedby="basic-addon2" class="form-control form-control-dark"
                          [minDate]="endDatepicker" [maxDate]="startDatemaxDate" name="date2" placeholder="Select Date"
                          ngbDatepicker #ed="ngbDatepicker">
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary" (click)="ed.toggle()" type="button"><i
                              class="fas fa-calendar"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-10">
                    <div class="col-md-6"></div>
                    <div class="col-md-4" style="margin-bottom:20px;">
                      <button type="button" style="width:100%" (click)="submitsetwindowdata()"
                        class="btn btn-info">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>